import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Rating from '@material-ui/lab/Rating';
import { hot } from 'react-hot-loader';

const useStyles = makeStyles({
	root: {
		width: 200,
		display: 'flex',
		alignItems: 'center',
		// marginLeft: '6%',
		marginRight: '50%'
	}
});

export default hot(module)(function RatingStars(props) {
	const [hover, setHover] = React.useState(0); //NOSONAR
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<Rating
				readOnly={props.readOnly || false}
				max={props.max}
				name={props.name}
				value={props.value}
				precision={0.1}
				onClick={props.onChangeValue}
				onChange={props.onChange}
				onChangeActive={(_event, newHover) => {
					setHover(newHover);
				}}
				size="large"
			/>
		</div>
	);
});
